import React from 'react';

export const demos = {
  'src-button-demo-ghost': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/home/runner/work/dumi-theme-chakra/dumi-theme-chakra/example/src/Button/demos/ghost.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "src-button-demo-ghost",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('-!/home/runner/work/dumi-theme-chakra/dumi-theme-chakra/example/src/Button/demos/ghost.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.1.0"
    },
    "@example/pkg": {
      "type": "NPM",
      "value": "0.0.1"
    }
  },
  "description": "ghost variant type button",
  "title": "ghost"
}
  },
  'src-button-demo-primary': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/home/runner/work/dumi-theme-chakra/dumi-theme-chakra/example/src/Button/demos/primary.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "src-button-demo-primary",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('-!/home/runner/work/dumi-theme-chakra/dumi-theme-chakra/example/src/Button/demos/primary.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.1.0"
    },
    "@example/pkg": {
      "type": "NPM",
      "value": "0.0.1"
    }
  },
  "description": "primary variant type button",
  "title": "primary"
}
  },
};
export const frontmatter = {"title":"Button 按钮","toc":"content","filename":"src/Button/index.zh-CN.md","nav":{"title":"组件","order":2},"group":"表单","description":"按钮组件用于触发一个动作或事件，如提交一个表单、打开一个对话框、取消一个动作或执行一个删除操作。"};
export const toc = [{"id":"button-按钮","depth":1,"title":"Button 按钮"},{"id":"引用","depth":2,"title":"引用"},{"id":"使用","depth":2,"title":"使用"},{"id":"src-button-demo-ghost","depth":3,"title":"ghost"},{"id":"src-button-demo-primary","depth":3,"title":"primary"},{"id":"参数","depth":2,"title":"参数"}];
export const texts = [{"value":"按钮组件用于触发一个动作或事件，如提交一个表单、打开一个对话框、取消一个动作或执行一个删除操作。","paraId":0,"tocIndex":0},{"value":"import { Button } from 'example';\n","paraId":1,"tocIndex":1}];
